module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"container\"> <div class=\"row pt-4\"> <div class=\"col-sm-7 col-lg-4 mx-auto\"> <div class=\"row\"> <div class=\"col-6 text-center mx-auto mb-4\"> <a href=\"/\"> <img src=\"/assets/images/branding/easypost-primary-logo.svg\" class=\"img-fluid\"> </a> </div> </div> <h4 class=\"mb-5 text-center\">Get started with a free account</h4> <form id=\"user_create_form\"> <label for=\"#signup-name\">First &amp; Last Name</label> <div class=\"form-group\"> <input class=\"form-control\" id=\"signup-name\" name=\"user[name]\" size=\"30\" type=\"text\" value=\"")
    ; __append(escapeFn( locals.name ))
    ; __append("\"> </div> <label for=\"#signup-email\">Email Address</label> <div class=\"form-group\"> <input class=\"form-control\" id=\"signup-email\" name=\"user[email]\" size=\"30\" type=\"email\" value=\"")
    ; __append(escapeFn( locals.email ))
    ; __append("\"> </div> <label for=\"#signup-phone_number\">Phone Number</label> <div class=\"form-group\"> <input class=\"form-control\" id=\"signup-phone_number\" name=\"user[phone_number]\" size=\"30\" type=\"text\" value=\"")
    ; __append(escapeFn( locals.phone_number ))
    ; __append("\"> </div> <label for=\"#signup-password\">Password</label> <div class=\"form-group\"> <input class=\"form-control\" id=\"signup-password\" name=\"user[password]\" size=\"30\" type=\"password\"> </div> <label for=\"#signup-password_confirmation\">Confirm Password</label> <div class=\"form-group\"> <input class=\"form-control\" id=\"signup-password_confirmation\" name=\"user[password_confirmation]\" size=\"30\" type=\"password\"> </div> <div class=\"form-group mt-4\"> <button class=\"btn btn-secondary btn-lg btn-block\" type=\"submit\"> Sign up </button> </div> <p> <small>* By signing up you accept the <a href=\"/privacy\">EasyPost Terms of Service</a>.</small> </p> </form> </div> </div> </div> <div class=\"text-center my-6\"> <a class=\"text-muted\" href=\"signin\">Already have an account?</a> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/sign_up/template.ejs
// module id = 1167
// module chunks = 1